<template>
  <div class="right-sta" v-loading="loading">
    <div class="flex-h flex-vc flex-jsb">
      <div class="left">
        <ChartNum
          name="计划数量"
          :num="option_stat.number"
          backgroundImage=""
          shadowColor=""
        />
        <ChartNum
          v-for="item in optionStatRe"
          :key="item.color"
          :name="item.name"
          :num="item.percent"
          :tipText="item.tipText || ''"
          :backgroundImage="item.lineColor"
          :shadowColor="item.shadowColor"
        />
      </div>
      <div class="chart-box">
        <!-- <RingLine :data="optionStat" ele="option" /> -->
        <Ring
          :name="'已授予'"
          :subtext="
            parseFloat(option_stat.total_qty) == 0
              ? '0%'
              : (
                  (
                    parseFloat(option_stat.award_qty) /
                    parseFloat(option_stat.total_qty)
                  ).toFixed(2) * 100
                ).toFixed(2) + '%'
          "
          :value="
            parseFloat(option_stat.total_qty) == 0
              ? 0
              : (
                  (parseFloat(option_stat.award_qty) /
                    parseFloat(option_stat.total_qty)) *
                  100
                ).toFixed(2)
          "
          :color1="'#FF6B99'"
          :color2="'#f0427a'"
          :color3="'#FF1960'"
          :shadowcolor="'rgba(255,107,153,0.5)'"
          :id="'sychart'"
          :subColor="'#ECF0F3'"
          :height="172"
        ></Ring>
      </div>
    </div>
    <div class="flex-h flex-vc flex-jsb mt-20">
      <div class="left">
        <ChartNum
          name="授予总数(股)"
          :num="option_stat.award_qty"
          backgroundImage=""
          shadowColor=""
        />
        <ChartNum
          name="成熟总数(股)"
          :num="option_stat.mature_qty"
          tipText=""
          backgroundImage="linear-gradient(90deg, #F06000 0%, #FF9651 100%);"
          shadowColor="rgba(255,160,97,0.50)"
        />
      </div>
      <div class="chart-box">
        <Canvasdash
          :id="'chartstop3'"
          :value="
            parseFloat(option_stat.award_qty) == 0
              ? 0
              : parseFloat(option_stat.mature_qty) /
                parseFloat(option_stat.award_qty)
          "
          :height="74"
          :color1="'#F06000'"
          :color2="'#FF9651'"
          :shadowcolor="'rgba(255,160,97,0.5)'"
          :shadowcolor2="'rgba(255,160,97,0.3)'"
          :name="'已成熟'"
        ></Canvasdash>
      </div>
    </div>
    <div class="flex-h flex-vc flex-jsb mt-20">
      <div class="left">
        <ChartNum
          name="成熟总数(股)"
          :num="option_stat.mature_qty"
          backgroundImage=""
          shadowColor=""
        />
        <ChartNum
          name="行权总数(股)"
          :num="option_stat.actual_qty"
          tipText=""
          backgroundImage="linear-gradient(224deg, #57EB99 0%, #0DCD63 100%)"
          shadowColor="rgba(255,160,97,0.50)"
        />
      </div>
      <div class="chart-box">
        <Canvasdash
          :id="'chartsbottom12'"
          :value="
            parseFloat(option.mature_qty) == 0
              ? 0
              : parseFloat(option.actual_qty) / parseFloat(option.mature_qty)
          "
          :height="74"
          :color1="'#0DCD63'"
          :color2="'#57EB99'"
          :shadowcolor="'rgba(87,235,153,0.5)'"
          :shadowcolor2="'rgba(87,235,153,0.3)'"
          :name="'已行权'"
        ></Canvasdash>
      </div>
    </div>
  </div>
</template>
<script>
import ChartNum from "@/components/business/chart-num";
// import RingLine from "@/components/charts/RingLine";
import { deepClone } from "@/utils/core";
import Canvasdash from "@/components/charts/canvasdash";
import Ring from "@/components/charts/ring";
export default {
  components: {
    ChartNum,
    Ring,
    Canvasdash,
  },
  props: {
    option: {
      type: Object,
      // eslint-disable-next-line vue/require-valid-default-prop
      default: {
        number: 0,
        total_qty: 0,
        award_qty: 0,
        surplus_qty: 0,
        mature_qty: 0,
        actual_qty: 0,
      },
    },
  },
  watch: {
    option(val, oval) {
      if (val !== oval) this.getDetail();
    },
  },
  computed: {
    optionStatRe() {
      const arr = JSON.parse(JSON.stringify(this.optionStat));
      return arr.reverse();
    },
  },
  data() {
    return {
      option_stat: {},
      optionStat: [],
      loading: false,
    };
  },
  mounted() {},
  methods: {
    getDetail() {
      this.loading = true;
      const res = deepClone(this.option);
      this.option_stat = res;
      this.optionStat = [
        {
          name: "剩余总数(股)",
          percent: Number(res.surplus_qty),
          color: "l(0) 0:#57EB99 1:#0DCD63",
          lineColor: "linear-gradient(rgb(236, 240, 243), rgb(236, 240, 243));",
          shadowColor: "rgba(0,0,0,0)",
        },
        {
          name: "授予总数(股)",
          percent: Number(res.award_qty),
          color: "l(0) 0:#F06000 1:#FF9651",
          lineColor:
            "linear-gradient(270deg, rgb(255, 107, 153) 0%, rgb(255, 25, 96) 100%);",
          shadowColor: "rgba(255,107,153,0.50)",
        },
        {
          name: "总股数(股)",
          percent: Number(res.total_qty),
          tipText:
            "<div>统计中的“已授予数”和“已成熟数”与授予记录<br/>中的“授予股数”和“已成熟数”不是简单的汇<br />总关系。</div><div>考虑了“已终止”状态的授予记录中“已回收数”<br />对统计中“已授予数”和“已成熟数”的影响。</div>",
        },
      ];
      this.loading = false;
    },
  },
};
</script>
<style lang="scss" scoped>
.right-sta {
  height: 100%;
  overflow-y: auto;
  .chart_title {
    margin-bottom: 17px;
  }
  /deep/ .chart-num {
    margin-bottom: 6px;
  }
  .mt-20 {
    margin-top: 33px;
  }
}
</style>
